export const API = 'API';
export const API_START = 'API_START';
export const API_END = 'API_END';
export const API_ERROR = 'API_ERROR';
export const ACCESS_DENIED = 'ACCESS_DENIED';

export const SET_CONFIG = 'SET_CONFIG';
export const SET_BUSINESSES = 'SET_BUSINESSES';
export const SET_BUSINESS = 'SET_BUSINESS';
export const CLEAR_BUSINESS = 'CLEAR_BUSINESS';
export const SET_SUBMISSION = 'SET_SUBMISSION';
